// extracted by mini-css-extract-plugin
export default {"outerContainer":"BootcampsList_outerContainer__SJ4Yw","innerContainer":"BootcampsList_innerContainer__8MIu6","title":"BootcampsList_title__r9xpO"};